import { AppContext } from "@/App";
import { PageLockContext } from "@/Components/PageLockProvider";
import React from "react";
import { CellContext } from "@tanstack/react-table";
import { Textarea } from "@/Components/ui/textarea";
interface TextCellProps extends CellContext<any, unknown> {
    maxLength?: number;
}

export const TextCell = ({ getValue, row: { index }, column: { id }, table, maxLength }: TextCellProps) => {
    const app = React.useContext(AppContext);
    const lock = React.useContext(PageLockContext);
    const editingEnabled = app.applicationUser?.userSettings?.inlineTableEditing ?? false;

    const initialValue = getValue<string>()
    // We need to keep and update the state of the cell normally
    const [value, setValue] = React.useState(initialValue)

    // When the input is blurred, we'll call our table meta's updateData function
    const onBlur = (val: string) => {
        setValue(val);
        table.options.meta?.updateData(index, id, val)
    }

    // If the initialValue is changed external, sync it up with our state
    React.useEffect(() => {
        setValue(initialValue)
    }, [initialValue])

    if (app.authLevel !== 3 && !lock.viewOnly && editingEnabled) { // only allow editing for non-viewers
        return (
            <Textarea
            key={id + "_text_input_" + index}
            id={id + "_text_input_" + index}
            className="w-full bg-transparent border-none focus:ring-0 resize-none min-h-[1.5em]"
            value={value}
            style={{ minHeight: "1.5em", height: "auto" }}
            rows={1}
            onChange={(e) => {
                setValue(e.target.value);
                const textarea = e.target as HTMLTextAreaElement;
                textarea.style.height = "auto";
                textarea.style.height = textarea.scrollHeight + "px";
            }}
            maxLength={maxLength ? maxLength : 250}
            onBlur={(e) => {
                onBlur(e.target.value);
            }}
            ref={el => {
                if (el) {
                el.style.height = "auto";
                el.style.height = el.scrollHeight + "px";
                }
            }}
            />
        )
    }
    return <div className="text-left">{initialValue as string}</div>
}